import React from "react";
import "./SaleProductCard.scss";
// import { useState } from "react";
import { Link } from "react-router-dom";

function SaleProductCard(props) {
  const isSold = props.data.available === "Sold";

  return (
    <>
      <Link
        className="sale-product"
        to={`/shop/${props.data.brand}/${props.data.jewellery}/product/${props.data.id}}`}
      >
        <div className="sale-product__image-wrapper">
          <img
            src={props.data.mainImage || "https://picsum.photos/200"}
            alt="product"
            className="sale-product__image"
          />
          {isSold && <span className="sale-product__sold-badge">SOLD</span>}
        </div>
        <h4 className="sale-product__title">{props.data.title}</h4>
        {!props.data.gemstone && (
          <p className="sale-product__metal">{props.data.metal}</p>
        )}
        {props.data.gemstone && (
          <p className="sale-product__gem">{`${props.data.metal}, ${props.data.gemstone}`}</p>
        )}
        {props.data.rrp && (
          <h4 className="product__rrp">{`Retail Price: £${props.data.rrp}`}</h4>
        )}
        <h4 className="sale-product__price">Was: £{props.data.price}</h4>
        <h4 className="sale-product__sale-price">
          Now: £{props.data.salePrice}
        </h4>
        <button className="sale-product__button">Shop Now</button>
      </Link>
    </>
  );
}

export default SaleProductCard;
